module.exports = __webpack_public_path__ + "static/media/picto-star.9ba0b464.svg";